import { render, staticRenderFns } from "./setExchangeRate.vue?vue&type=template&id=6b861f44&scoped=true"
import script from "./setExchangeRate.vue?vue&type=script&lang=js"
export * from "./setExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./setExchangeRate.vue?vue&type=style&index=0&id=6b861f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b861f44",
  null
  
)

export default component.exports